import { Injectable, Inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { ThemeService } from '@awp/theme';
import { Router } from '@angular/router';

import { SirenHttp, AuthenticationService, getLink, SirenResponse, AUTH_SERVICE } from '@awp/http';
import { ApiLink, ApiInsuranceType } from '@awp/quote/models';
import { Card } from '../card.model';

@Injectable()
export class CardService {

  constructor(
    private http: SirenHttp,
    private router: Router,
    private themeService: ThemeService,   
    @Inject(AUTH_SERVICE) private authService: AuthenticationService) { }

  public getCards(binNumber: string, insuranceType: ApiInsuranceType): Observable<any> {
    return this.authService.authenticate()
    
      .pipe(
        switchMap(response => {
          const link = insuranceType === ApiInsuranceType.TravelInsurance
            ? getLink(ApiLink.TravelInsuranceCards, response)
            : getLink(ApiLink.OtherInsurancesCards, response);
          return this.http.get<SirenResponse>(link, { route: { bin: binNumber } })
            .pipe(
              map((binNumberResponse: SirenResponse) => {
                if (binNumberResponse != null && binNumberResponse.entities != null) {
                  const result = binNumberResponse.entities.map(item => {
                    return {
                      ...item.properties
                    };
                  })
                  return result as Card[];
                }
                return null;
              }),
              catchError(err => {
                var stopSellError = (err && err.error && err.error.messageCodes &&
                  err.error.messageCodes.length > 0)
                  ? err.error.messageCodes[0] : null;              
                if (stopSellError != null && err instanceof HttpErrorResponse && err.status === 404)   {
                  const tree = this.router.createUrlTree(['/page/not-found']);
                  this.router.navigateByUrl(tree, { replaceUrl: true });                 
                }
                if (err instanceof HttpErrorResponse && err.status === 404) {
                  return of(null);
                }
                if (err instanceof HttpErrorResponse && err.status === 409) {
                  return of(err.status);
                }
                throw err;
              })
            );
        })
      );
  }
}
